import { render, staticRenderFns } from "./CourseHistory.vue?vue&type=template&id=bd923da6"
import script from "./CourseHistory.vue?vue&type=script&lang=js"
export * from "./CourseHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports